import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import Stack from "./Stack.mjs";
import useComputedCSSGridColumns from "./useComputedCSSGridColumns.mjs";
import "./Accordion.mjs";
import "./Alert.mjs";
import useThemeProps from "./useThemeProps.mjs";
import "lodash";
import "./backgroundColorContext.mjs";
import "react";
import "chroma-js";
import "./Box.mjs";
import "./Breadcrumbs.mjs";
import "./Button.mjs";
import "./Card.mjs";
import "./cardComponentContext.mjs";
import "./CardMedia.mjs";
import "./CardTitle.mjs";
import "./Checkbox.mjs";
import "usehooks-ts";
import "uid";
import "./InlineList.mjs";
import "./useClickable.mjs";
import "./ClickableIcon.mjs";
import "./ConfirmDialog.mjs";
import "./ContactCard.mjs";
import "lodash/memoize";
import "lodash/flattenDeep";
import "lodash/isArray";
import "lodash/mapValues";
import "lodash/pickBy";
import "lodash/isPlainObject";
import "lodash/capitalize";
import "./timeAgo.mjs";
import "react-i18next";
import "date-fns/format";
import "./dateIntervalContext.mjs";
import "./Details.mjs";
import "./DevNotice.mjs";
import "./Divider.mjs";
import "./DropdownNav.mjs";
import "./Typography.mjs";
import "./Grid.mjs";
import "./GridButton.mjs";
import "./groupConsecutiveWith.mjs";
import "./H.mjs";
import "./handleComponentsProp.mjs";
import "./Heading.mjs";
import "./iconContext.mjs";
import "clsx";
import "./IconButton.mjs";
import "./ListButton.mjs";
import "./ListStack.mjs";
import "./mergeAndConcat.mjs";
import "./mergeProps.mjs";
import "./mergeThemes.mjs";
import "./OutlineNav.mjs";
import "./pageGridContext.mjs";
import "./Pagination.mjs";
import "./headingLevelContext.mjs";
import "./SlidePanel.mjs";
import "./Tab.mjs";
import "./Table.mjs";
import "./tabListContext.mjs";
import "./TearOffDate.mjs";
import "./TeaserBadge.mjs";
import "./TeaserMeta.mjs";
import "./TimelineSeparator.mjs";
import "./TreeMenu.mjs";
import "./TypographyBlock.mjs";
import "immer";
import "lodash/fp/camelCase";
import "./urlTransformerContext.mjs";
import "date-fns";
import "hash-sum";
function MixedGridLayout(props) {
  props = useThemeProps({
    props,
    name: "MixedGridLayout"
  });
  let {
    columnMinWidth = 80,
    columnGap = 6,
    rowGap = 4,
    className,
    items,
    renderItem,
    ...restProps
  } = props;
  const theme = useTheme();
  columnMinWidth = theme.getLength(columnMinWidth);
  columnGap = theme.getLength(columnGap);
  rowGap = theme.getLength(rowGap);
  const [columns = [], ref] = useComputedCSSGridColumns([columnMinWidth, columnGap, className
  // JSON.stringify(styles),
  ]);
  let groups = columns.map(column => ({
    ...column,
    items: []
  }));
  if (columns.length) {
    items.forEach((item, index) => {
      let group = groups[Math.min(index, groups.length - 1)];
      group.items.push(item);
    });
  }
  let itemIndex = 0;
  return /* @__PURE__ */jsx("div", {
    className,
    ref,
    ...restProps,
    css: /* @__PURE__ */css("display:grid;grid-template-columns:repeat(\n          auto-fit,\n          minmax(min(100%, ", columnMinWidth, "), 1fr)\n        );row-gap:", rowGap, ";column-gap:", columnGap, ";align-items:stretch;" + (process.env.NODE_ENV === "production" ? "" : ";label:MixedGridLayout;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    children: groups.map((_ref, columnIndex) => {
      let {
        items: items2,
        ...columnProps
      } = _ref;
      if (!items2.length) return null;
      return /* @__PURE__ */jsx(Stack, {
        direction: "column",
        spacing: rowGap,
        justifyContent: "start",
        children: items2.map((item, columnItemIndex) => {
          return renderItem(item, {
            isFirstColumn: columnIndex === 0,
            isLastColumn: columnIndex === groups.length - 1,
            isFirstItem: itemIndex === 0,
            isFirstColumnItem: columnItemIndex === 0,
            itemIndex: itemIndex++,
            columnIndex,
            columnItemIndex,
            columnItemCount: items2.length,
            columnCount: columns.length,
            ...columnProps
          });
        })
      }, columnIndex);
    })
  });
}
export { MixedGridLayout as default };